/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const OCC_CART_ID_CURRENT = 'current';

export * from './occ-user-ids';
